// Общие запросы: каталог (направления, цены, миры), «кто я» и документы.
import { useQuery } from "@tanstack/react-query";
import { isApiError } from "../api/client";
import { getCatalog, getDocument, getDocuments, getMe } from "../api/endpoints";
import type { MeView } from "../api/types";

export const CATALOG_KEY = ["catalog"] as const;
export const ME_KEY = ["me"] as const;
export const DOCUMENTS_KEY = ["documents"] as const;
// «Мои заказы»: ключ здесь, а не в экране — развилка Mini App не тянет код экрана заказов (seo).
export const ORDERS_KEY = ["orders"] as const;

export function useCatalog() {
  return useQuery({ queryKey: CATALOG_KEY, queryFn: getCatalog, staleTime: 5 * 60_000 });
}

// Кто вошёл. null — гость: сервер ответил «нужен вход».
async function fetchMe(): Promise<MeView | null> {
  try {
    return await getMe();
  } catch (error) {
    if (isApiError(error) && error.kind === "unauthorized") {
      return null;
    }
    throw error;
  }
}

// fresh — перезапросить при открытии экрана: бесплатная попытка могла потратиться с тех пор.
export function useMe({ fresh = false }: { fresh?: boolean } = {}) {
  return useQuery({
    queryKey: ME_KEY,
    queryFn: fetchMe,
    staleTime: 60_000,
    refetchOnMount: fresh ? "always" : true,
  });
}

// Документы меняются редко. Даты редакций из списка уходят с согласиями (documentRevisions.ts).
export function useDocuments() {
  return useQuery({ queryKey: DOCUMENTS_KEY, queryFn: getDocuments, staleTime: 5 * 60_000 });
}

export function useDocument(documentId: string) {
  return useQuery({
    queryKey: [...DOCUMENTS_KEY, documentId],
    queryFn: () => getDocument(documentId),
    staleTime: 5 * 60_000,
  });
}

